import script from "./DescriptionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DescriptionModal.vue?vue&type=script&setup=true&lang=ts"

import "./DescriptionModal.vue?vue&type=style&index=0&id=c09b4b62&lang=scss&scoped=true"
import "./DescriptionModal.vue?vue&type=style&index=1&id=c09b4b62&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c09b4b62"]])

export default __exports__